import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { SelectProviderDataService } from '@app/login/data/select-provider-data/select-provider-data.service';
import { catchError, map, Observable, of, take } from 'rxjs';

export const providerConfigGuard: CanMatchFn = (): Observable<boolean | UrlTree> => {
  const selectProviderDataService = inject(SelectProviderDataService);
  const router = inject(Router);

  const providerId = sessionStorage.getItem('provider');

  if (!providerId) {
    return of(router.createUrlTree(['/login']));
  }

  // avoid refetching on every navigation within the provider section
  if (selectProviderDataService.isProviderLoaded(providerId)) {
    return of(true);
  }

  return selectProviderDataService.setProvider$(providerId).pipe(
    take(1),
    map(() => true),
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse && err.status === 503) {
        return of(router.createUrlTree(['/error', '503']));
      }

      const nav = router.getCurrentNavigation(); // router.currentNavigation() on Angular 20+
      const url = nav ? router.serializeUrl(nav.extractedUrl) : '/';
      sessionStorage.setItem('provider_config_redirect', url);
      return of(router.createUrlTree(['/provider-config-error']));
    })
  );
};
